import React from 'react'

import { SectionLinks } from '@src/types/navigation'

import SectionLinksColumn from '../section/SectionLinksColumn'

type Props = {
  sections: SectionLinks[]
}

export default function SectionsLinksGrid({ sections }: Props) {
  return (
    <section className='grid grid-cols-3 gap-8'>
      {sections.map((section) => (
        <SectionLinksColumn key={`section_${section.title}`} section={section} />
      ))}
    </section>
  )
}
